export default "__VITE_ASSET__CK_HX9ST__"